import router from "@/router";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const GlobalParameterRepository = RepositoryFactory.get("globalParameters");

const state = {
  parameters: [],
};

const getters = {
  /**
   * Return future_update_date as a date, or null.
   *
   * @param {*} state
   * @returns Date|null
   */
  getFutureUpdateParam: (state) => {
    try {
      let date = new Date(
        state.parameters.find(
          (element) => element.code === "future_update_date",
        ).value,
      );

      if (date.toString() === "Invalid Date") return null;
      return date;
    } catch (error) {
      return null;
    }
  },
};

const actions = {
  list({ commit, dispatch }) {
    dispatch("loadings/enableLoadings", {}, { root: true });

    return GlobalParameterRepository.list()
      .then((response) => {
        commit("SET_GLOBAL_PARAMETERS", response.data.results);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.globalParameters.listError`,
            ),
          },
          { root: true },
        );
      })
      .finally(() => {
        dispatch("loadings/disableLoadings", {}, { root: true });
      });
  },
  simplifiedList({ commit, dispatch, rootGetters }) {
    // don't load simplified list if the app is mounted by admin on GlobalParameters page: full list will be loaded
    if (
      rootGetters["users/isAdmin"] &&
      router.currentRoute.value.name === "AdminGlobalParameter"
    ) {
      return;
    }

    return GlobalParameterRepository.simplifiedList()
      .then((response) => {
        commit("SET_GLOBAL_PARAMETERS", response.data.results);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.globalParameters.listError`,
            ),
          },
          { root: true },
        );
      });
  },
  update({ dispatch, commit }, payload = {}) {
    const globalParamId = payload.id;

    return GlobalParameterRepository.patch(globalParamId, payload)
      .then(() => {
        commit("UPDATE_PARAM_VALUE", payload);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.globalParameters.updateValueError`,
            ),
          },
          { root: true },
        );
      });
  },
};

const mutations = {
  SET_GLOBAL_PARAMETERS(state, parameters) {
    state.parameters = parameters;
  },
  UPDATE_PARAM_VALUE(state, payload) {
    let i = state.parameters.findIndex((r) => r.id === payload.id);
    state.parameters[i].value = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
